import Vue from 'vue'
import Vuex from 'vuex'
import KYCFormStore from '@/views/kyc-form/KYCFormStore'
import KYCPdfStore from '@/views/kyc-pdf/KYCPdfStore'
import KYCSectionStore from './KYCSectionStore'
import KYCPdfSectionStore from './KYCPdfSectionStore'
import KYCSubmissionStore from './modules/KYCSubmissionStore'
import BscStore from '@core/pages/bsc/store/BscStore'
import ClientInfoStore from '@core/pages/client-management/master-view/ClientInfoStore'
import ComplianceStore from '@core/pages/compliance/store/ComplianceStore'
import ClientPolicyStore from '@core/pages/new-business-register/store/ClientPolicyStore'
import ScheduleStore from '@core/pages/scheduler/store/ScheduleStore'
import UserStore from '@core/pages/userProfile/store/UserStore'
import ClientStore from '@core/store/ClientStore'
import HierarchySetupStore from '@core/pages/hierarchy-setup/store/HierarchySetupStore'
import ProductStore from '@core/store/ProductStore'
import MyinfoStore from '@core/pages/individual-myinfo/MyinfoStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {}
  },
  getters: {
    currentUser (state) {
      return state.user
    }
  },
  mutations: {
    setCurrentUser (state, user) {
      if (user == null) {
        state.user = {}
      } else {
        Object.assign(state.user, user)
      }
    }
  },
  actions: {
    login (context, user) {
      context.commit('setCurrentUser', user)
    },
    logout (context) {
      context.commit('setCurrentUser', null)
    }
  },
  modules: {
    KYCFormStore,
    KYCPdfStore,
    KYCSectionStore,
    KYCPdfSectionStore,
    KYCSubmissionStore,
    UserStore,
    ClientPolicyStore,
    ClientInfoStore,
    ClientStore,
    BscStore,
    ComplianceStore,
    ScheduleStore,
    HierarchySetupStore,
    ProductStore,
    MyinfoStore
  }
})
